import React, { useState, useCallback, useEffect, useRef } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import { SelectBox } from 'devextreme-react/select-box';
import { FileUploader } from 'devextreme-react/file-uploader';
import axios from "axios";
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import { LoadPanel } from 'devextreme-react/load-panel';
import notify from 'devextreme/ui/notify';
import { alert, confirm } from 'devextreme/ui/dialog';
import Toolbar, { Item } from "devextreme-react/toolbar";
import { custom } from 'devextreme/ui/dialog';
import ValidationSummary from 'devextreme-react/validation-summary';
import PrimaryTab from "./tabs/PrimaryTab";

const FILE_PURPOSES = [
    'assistants',
    'assistants_output',
    'batch',
    'batch_output',
    'fine-tune',
    'fine-tune-results',
    'vision',
    'user_data'
];

function Form(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const initialFormFields = {
        Id: '',
        FileName: '',
        Bytes: null,
        CreatedAt: null,
        Purpose: '',
        Status: '',
        ExpiresAt: null,
        PurposeUpload: 'user_data'
    };

    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [formFields, setformFields] = useState(initialFormFields);
    const [selectedFile, setSelectedFile] = useState(null);
    const fileUploaderRef = useRef(null);
    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, []);
    const position = { of: '#accordion-containe2' };
    const formRefs = useRef({});
    const isEditMode = Boolean(props.id);

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (!isEditMode) {
            await uploadFile();
        }
        // Edit mode: no save (files are read-only per OpenAI API)
    };

    const uploadFile = async () => {
        if (!selectedFile) {
            notify({ message: "Please select a file to upload", width: 100 }, 'warning', 3000);
            return;
        }
        setLoadPanelVisible(true);
        setIsFormSubmitted(true);
        try {
            const url = "ai/file/UploadFile";
            const formData = new FormData();
            formData.append('file', selectedFile);
            formData.append('purpose', formFields.PurposeUpload || 'assistants');

            const response = await axios.post(`${window._env_.REACT_APP_APIS}/${url}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`
                },
            });
            if (response.status === 200 && response.data) {
                const data = response.data;
                setformFields(prev => ({
                    ...prev,
                    Id: data.id,
                    FileName: data.fileName,
                    Bytes: data.bytes,
                    CreatedAt: data.createdAt,
                    Purpose: data.purpose,
                    Status: data.status,
                    ExpiresAt: data.expiresAt
                }));
                notify({ message: "File uploaded successfully", width: 100 }, 'success', 3000);
                setIsFormSubmitted(false);
            } else {
                notify({ message: "Could not upload file. An error occurred", width: 100 }, 'error', 3000);
                setIsFormSubmitted(false);
            }
        } catch (error) {
            console.error('Error uploading file:', error);
            if (error.response?.data?.ERRORS && error.response.data.ERRORS.length > 0) {
                const errorHtml = error.response.data.ERRORS.map(err => `<div>${err}</div>`).join('');
                custom({
                    title: "Errors",
                    messageHtml: errorHtml,
                    buttons: [{ text: "OK", onClick: () => {} }]
                }).show();
            } else {
                notify({
                    message: error.response?.data?.message || "Could not upload file. An error occurred",
                    width: 100,
                }, 'error', 3000);
            }
            setIsFormSubmitted(false);
        } finally {
            setTimeout(hideLoadPanel, 1000);
        }
    };

    const primaryFormLookupsLoad = () => {
        primaryFormLoad();
    };

    const primaryFormLoad = () => {};

    const handleReset = () => {
        const id = props.id;
        if (id != null && id !== undefined && id !== '') {
            GetFileById(id);
        } else if (formFields.Id != null && formFields.Id !== undefined && formFields.Id !== '') {
            GetFileById(formFields.Id);
        } else {
            setformFields(initialFormFields);
            setSelectedFile(null);
            if (fileUploaderRef.current?.instance()) {
                fileUploaderRef.current.instance().reset();
            }
        }
    };

    const DeleteClick = async () => {
        const result = confirm("<i>Are you sure you want to delete this file?</i>", "Delete");
        result.then(async (dialogResult) => {
            if (dialogResult) {
                setLoadPanelVisible(true);
                try {
                    const response = await axios.post(
                        `${window._env_.REACT_APP_APIS}/ai/file/DeleteFile`,
                        formFields.Id,
                        {
                            headers: {
                                'Content-Type': 'application/json',
                                access_token: accessToken,
                                Authorization: `Bearer ${accessToken}`
                            },
                        }
                    );
                    if (response.data?.deleted) {
                        notify({ message: "File deleted", width: 100 }, 'success', 3000);
                        setLoadPanelVisible(false);
                        history.push('/ai/file-data-entry');
                    } else {
                        notify({ message: "Could not delete file", width: 100 }, 'error', 3000);
                        setLoadPanelVisible(false);
                    }
                } catch (error) {
                    setLoadPanelVisible(false);
                    notify({ message: "Could not delete file. An error occurred", width: 100 }, 'error', 3000);
                }
            }
        });
    };

    const DownloadClick = async () => {
        setLoadPanelVisible(true);
        await axios
        .get(
            `${window._env_.REACT_APP_APIS}/ai/file/GetFileContent?Id=${formFields.Id}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                }
            }
        )
        .then((res) => {
            setLoadPanelVisible(false);
            const link = document.createElement("a");
            link.target = "_blank";
            link.download = res.headers.filenmae;
            var blob = new Blob([res.data], { type: "application/octet-stream" });
            link.href = URL.createObjectURL(blob);
            link.click();
        })
        .catch((err) => {
            setLoadPanelVisible(false);
            if(err.response.data.error.message) {
                alert(err.response.data.error.message, "Error");
            }
            else {
                alert("Could not download file. An error occurred", "Error");

            }
        });

        /* 
        const url = `${window._env_.REACT_APP_APIS}/ai/file/GetFileContent?Id=${formFields.Id}`;
        window.open(url, '_blank'); 
        */
    };

    const addNewRecordClick = () => {
        setIsFormSubmitted(false);
        setformFields(initialFormFields);
        setSelectedFile(null);
        if (fileUploaderRef.current?.instance()) {
            fileUploaderRef.current.instance().reset();
        }
        history.push('/ai/add-file');
    };

    const GetFileById = (id) => {
        setLoadPanelVisible(true);
        axios.get(`${window._env_.REACT_APP_APIS}/ai/file/GetFile?Id=${encodeURIComponent(id)}`, {
            headers: {
                access_token: accessToken,
                Authorization: `Bearer ${accessToken}`
            }
        }).then((res) => {

            const responseData = res.data;
            if (responseData.Id) 
            {
                setformFields(responseData);
            }
            else 
            {
                console.error('Failed to get File data');
            }
        }).catch((err) => {
            console.error('Failed to get file:', err);
            notify({ message: "Failed to load file", width: 100 }, 'error', 3000);
        }).finally(() => {
            setTimeout(hideLoadPanel, 1000);
        });
    };

    useEffect(() => {
        const id = props.id;
        if (id != null && id !== undefined && id !== '') {
            GetFileById(id);
        }
    }, [props.id]);

    const goBack = () => {
        history.push("/ai/file-data-entry");
    };

    const handleFieldChange = useCallback((name, value) => {
        if (name === 'PurposeUpload') {
            setformFields(prev => ({ ...prev, PurposeUpload: value }));
        }
    }, []);

    const handleFileUploaderValueChanged = useCallback((e) => {
        const file = e.value?.[0];
        setSelectedFile(file || null);
        if (file) {
            setformFields(prev => ({ ...prev, Filename: file.name }));
        }
    }, []);

    return (
        <div>
            <div className="row dataEntryMainPage">
                <div className="col-md-12 main-page">
                    <div id="accordion">
                        <LoadPanel
                            shadingColor="rgba(0,0,0,0.4)"
                            position={position}
                            onHiding={hideLoadPanel}
                            visible={loadPanelVisible}
                            showIndicator={true}
                            shading={true}
                            showPane={true}
                            hideOnOutsideClick={false}
                        />
                        <form onSubmit={(e) => handleFormSubmit(e)}>
                            <Toolbar className="header">
                                <Item location="before">
                                    <div className="title">
                                        <h6 style={{ color: window._env_.Color2, marginLeft: '12px' }}>
                                            OpenAI Files Data Entry
                                        </h6>
                                    </div>
                                </Item>
                                {(!isEditMode && (formFields.Id == '' || formFields.Id == null || formFields.Id == undefined)) && (
                                    <Item location="after">
                                        <Button
                                            text="Save"
                                            useSubmitBehavior={true}
                                            disabled={isFormSubmitted}
                                            type="default"
                                            className="accordianButton"
                                        />
                                    </Item>
                                )}
                                <Item location="after">
                                    <Button
                                        className="accordianButton"
                                        onClick={DownloadClick}
                                        text="Download"
                                        disabled={!formFields.Id}
                                        type="default"
                                    />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={addNewRecordClick} text="New" type="default" />
                                </Item>
                                <Item location="after">
                                    <Button
                                        className="accordianButton"
                                        onClick={DeleteClick}
                                        text="Delete"
                                        disabled={!formFields.Id || 
                                            formFields.Id == "file-GFQ3vL6csj1sRP6kBd7m5s" ||
                                            formFields.Id == "file-GaNMqzjE97CQQHERsUTLWZ" ||
                                            formFields.Id == "file-LZwyUNp36koZhaC5hVojb9" ||
                                            formFields.Id == "file-4neCHYPSoR9GREMJvzSUqj" ||
                                            formFields.Id == "file-E5FQnVF3tmGzFjK2B6m7MW" ||
                                            formFields.Id == "file-9zoTw2CExPeiCfttpmKdim" ||
                                            formFields.Id == "file-624zXjeVFboqdih8nCoHUw" ||
                                            formFields.Id == "file-8dGoE7LgnYST4mKhnao8sJ" ||
                                            formFields.Id == "file-L6utDLs5YRNBYQE1MubaWZ" ||
                                            formFields.Id == "file-LWygxswhNoMbtJXaqA83NX" ||
                                            formFields.Id == "file-95GpnxDpECYtCvcc3mTSa5" ||
                                            formFields.Id == "file-H4kwGo5kabyrPVVF39m28w" ||
                                            formFields.Id == "file-Lwbqi42h4htaddEt3BGZuQ" ||
                                            formFields.Id == "file-B5YSSdqsFpzbrUiQcYeF2U" ||
                                            formFields.Id == "file-Nez2UxW1dPXYcT4MqrfZWh" ||
                                            formFields.Id == "file-7vCnv6vtnnxz9YcmGro4qt" ||
                                            formFields.Id == "file-JPh4uZS9VnXiS8fvcDWH3M" ||
                                            formFields.Id == "file-RQXTiSfDZykTLBtzTiwErd" ||
                                            formFields.Id == "file-A6DgNEpShM1ceUUZMaYdse" ||
                                            formFields.Id == "file-DpJAeUV1ygXFo55G5Rnmym" ||
                                            formFields.Id == "file-5fG2nW8cC69S9VSGPKvgge" ||
                                            formFields.Id == "file-5QmrPXsmiJqwA17xbvxL3m" ||
                                            formFields.Id == "file-Vc2jNjRoxCpFUzWSNmFi3b" ||
                                            formFields.Id == "file-NKFrhBqaLjmzSWgbG7ghXh" ||
                                            formFields.Id == "file-5NyT5Eu4omDsNxbgj2PqbX" ||
                                            formFields.Id == "file-GMdoa5MYfVjspg7cHvR3QF" ||
                                            formFields.Id == "file-R6pcfYeaUi78g8RjcwB7Tv" ||
                                            formFields.Id == "file-EYZkedbU9xifCWWiC7yiqx" ||
                                            formFields.Id == "file-HbUxV7VGEVdBT82r56DVhw" ||
                                            formFields.Id == "file-CQKpdXxvWj2RVTbLmAhyxF" ||
                                            formFields.Id == "file-JRUEDa4bHEHYX4PkxRE5vN" ||
                                            formFields.Id == "file-YcKyZG8v4kq6zndyWGwkRe" ||
                                            formFields.Id == "file-4PDHrTTGuVGcDGC5LeyYi8" ||
                                            formFields.Id == "file-Hu9P6oBBupyq4iTMvQaTu9" ||
                                            formFields.Id == "file-UnWSYTP5gMwt6NrFqPfhoE" ||
                                            formFields.Id == "file-7cRM9sSazTJeo83n1ky3Pe" ||
                                            formFields.Id == "file-L7wWmVBhHzRj1qRNfQoojg" ||
                                            formFields.Id == "file-3xK1LLzqwmEDjWZLb1vAkZ" ||
                                            formFields.Id == "file-TAANSzsqa6gUjoKzuTPkJn" ||
                                            formFields.Id == "file-3KieaYDzNSUeCSZkXDyRYk"      
                                        }
                                        type="default"
                                    />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={goBack} text="Back" disabled={props.isOpenAsPopUp} />
                                </Item>
                            </Toolbar>
                            {(!isEditMode && (formFields.Id == '' || formFields.Id == null || formFields.Id == undefined)) && (
                                <div className='row' >
                                    <div className='col-md-3'>
                                        <FileUploader
                                            ref={fileUploaderRef}
                                            accept="*"
                                            uploadMode="useForm"
                                            multiple={false}
                                            onValueChanged={handleFileUploaderValueChanged}
                                            stylingMode="outlined"
                                            labelMode="static"
                                            label="Choose file"
                                        />
                                    </div>
                                    <div className='col-md-3' style={{ marginTop: '10px' }}>
                                        <SelectBox
                                            dataSource={FILE_PURPOSES}
                                            value={formFields.PurposeUpload}
                                            onValueChanged={(e) => handleFieldChange('PurposeUpload', e.value)}
                                            stylingMode="outlined"
                                            labelMode="static"
                                            label="Purpose"
                                        />
                                    </div>
                                    <div className="col-md-3">&nbsp;</div>
                                    <div className="col-md-3">&nbsp;</div>
                                </div>
                            )}
                            <PrimaryTab
                                formFields={formFields}
                                setformFields={setformFields}
                                handleFieldChange={handleFieldChange}
                                handleSelectionChange={() => {}}
                                primaryFormLookupsLoad={primaryFormLookupsLoad}
                                formRefs={formRefs}
                                isEditMode={isEditMode}
                                hasFile={!!formFields.Id}
                            />
                            <div className="row">
                                <ValidationSummary className="pl-3 pt-1" id="summary" />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(Form);
